import * as React from 'react';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags
import 'flag-icon-css/css/flag-icon.css';

// services
import {createItemGen, currentBaseUrl, currentUser, isUserLoggedIn, setSubscriptionData} from '../../common/services';

// components
import Loader from 'react-loader'
import NavBar from '../../components/CustomNav/CustomNav.Component';

// router
import { Redirect } from "react-router-dom";

// toast component
import { toast, ToastContainer} from 'react-toastify';

import StripeCheckout from 'react-stripe-checkout';

import './packagesPage.css';

// reactstrap

// tabs
import {Breadcrumb, BreadcrumbItem, Button, Col, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap';

class PackagesPage extends React.Component {
    public state = {
      activePackage: 0,
      baseurl: currentBaseUrl(),
      destination: '',
      loaded: true,
      mounted: false,
      navigate: false,
      packagemodal: false,
      packages: [
                 {
                     'amount': 500,
                     'description': 'Simple Package',
                     'level': 1,
                     'id': 2
                 },
                 {
                    'amount': 800,
                    'description': 'Basic Package',
                    'level': 2,
                    'id': 3
                },
                {
                    'amount': 1200,
                    'description': 'Pro Package',
                    'level': 3,
                    'id': 4
                },
                {
                    'amount': 2000,
                    'description': 'Ultimate Package',
                    'level': 4,
                    'id': 5
                }
                ],
      stripeKey: 'pk_test_XyOZ6N0dkRmxhBKACp1Jc5z5',
      tologin: false,
      username: '',
    }

    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
        this.packagetoggle = this.packagetoggle.bind(this);
        this.setPackage = this.setPackage.bind(this);
        this.onToken = this.onToken.bind(this);
        this.handleGenCreatedItemLoaded = this.handleGenCreatedItemLoaded.bind(this);
    }

    public packagetoggle() {
        this.setState({
          packagemodal: !this.state.packagemodal,
        });
    }

    public setPackage(param, e) {
        this.setState({
        activePackage: param
         });

         this.packagetoggle()
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public openWidget(param, e) {
        console.log('widget: ' + param)
        this.setState({destination: currentBaseUrl() + param})
        this.setState({navigate: true})
    }

    public onChange(arg) {
        console.log('On change', arg);
    }

    public componentDidMount() {

        if(!isUserLoggedIn()){
            this.setState({ tologin: true });
          }
        else{
            this.setState({ username: currentUser()});
        }

        this.setState({ mounted: true});
    }


    public onToken = (token) => {
        // TODO: Send the token information and any other
        // relevant information to your payment process
        // server, wait for the response, and update the UI
        // accordingly. How this is done is up to you. Using
        // XHR, fetch, or a GraphQL mutation is typical.
        // console.log(token);
        this.setState({ loaded: false});
        this.packagetoggle();

        const item = {
            'package': JSON.stringify(this.state.packages[this.state.activePackage]),
            'token': JSON.stringify(token)
        }
        console.log(item);
        createItemGen( 'admin/userprofiles/upgrade_profile/', item, text => this.handleGenCreatedItemLoaded(text));
    };

    public handleGenCreatedItemLoaded(res) {
        this.setState({ loaded: true});

        if(res.code ===200){
            toast.success('Request successful');

            console.log(res.response);
            setSubscriptionData(res.response.data);
            this.setState({destination: currentBaseUrl() + 'home'})
            this.setState({navigate: true})
        }
        if(res.code ===404){
            toast.error('Request failed, try again');
        }
        if(res.code ===401){
            toast.warn('Request unauthorized');
            this.onLogout('arg');
        }
    }

    public packagesTable () {
        return (
            <div className="packages-container">
            <div style={{width: "80%", marginTop: "3em"}}>
                    <p className="go-back" onClick={this.openWidget.bind(this, "home")}>{" "} &lt; Back{" "}</p>
                </div>
                <Row>                    
                    <h4 className="packages-header">PL Packages</h4>
                </Row>
           
                <Table
                    dark = {true}
                    borderless = {true}
                    className="packages-table">
                    <thead>
                        <tr>
                            <th>Features</th>
                            <th>Simple</th>
                            <th>Basic</th>
                            <th>Pro</th>
                            <th>Ultimate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Preassessments</th>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Email Reminders</th>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Lessons</th>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">PDF Reports</th>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">SMS Reminders</th>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Adaptive Learning</th>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Private Tutor</th>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-ban"/></p>
                            </td>
                            <td>
                                <p><i className="fa fa-check"/></p>
                            </td>
                        </tr>
                        <tr>
                            <th/>
                            <td>
                                <button className= "blue-button pay-button" style={{opacity: 1.0}} onClick={this.setPackage.bind(this, 0)}>Pay €30.00</button>
                            </td>
                            <td>
                                <button className= "blue-button pay-button" onClick={this.setPackage.bind(this, 1)}>Pay €50.00</button>
                            </td>
                            <td>
                                <button className= "blue-button pay-button" onClick={this.setPackage.bind(this, 2)}>Pay €90.00</button>
                            </td>
                            <td>
                                <button className= "blue-button pay-button" onClick={this.setPackage.bind(this, 3)}>Pay €120.00</button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>

        );

    }

    public render() {
        if (this.state.tologin === true) {
           return <Redirect to='/login'/>
        }
        if (this.state.navigate === true) {
            return <Redirect to={this.state.destination}/>
        }

        return (
            <div>

              <NavBar logoutParent={this.onLogout}/>

              {/* <Breadcrumb>
                  <BreadcrumbItem><a onClick={this.openWidget.bind(this, 'home')}>Home</a></BreadcrumbItem>
                  <BreadcrumbItem active={true}>Packages</BreadcrumbItem>
                </Breadcrumb> */}
                

              <div className="animated fadeIn">
                <Loader color="#3EE9F7" loaded={this.state.loaded}/>
                <Modal isOpen={this.state.packagemodal} toggle={this.packagetoggle} className="" centered={true}>
                        <ModalHeader toggle={this.packagetoggle}>
                            Pay With Card
                            <p>Thank you for choosing to improve your education! We look forward to getting you started.</p>
                            <p>You have chosen the {this.state.packages[this.state.activePackage].description}</p>
                        </ModalHeader>
                        <ModalBody>
                            <StripeCheckout
                                amount={this.state.packages[this.state.activePackage].amount}
                                description={this.state.packages[this.state.activePackage].description}
                                image="http://staging.mypl.life/static/media/pl_logo.c766edb4.png"
                                locale="auto"
                                name="mypl.life"
                                stripeKey={this.state.stripeKey}
                                token={this.onToken}
                            />
                        </ModalBody>
                </Modal>
                
                {this.packagesTable()}

              </div>

            </div>
        )
    }
}

export default PackagesPage;


// WEBPACK FOOTER //
// ./src/pages/Subscription/packagesPage.Component.tsx